import isStreamVideo from '@anm/helpers/is/isStreamVideo';
import { MediaObject } from '@anm/hosting-player/types';
import { useEffect, useState } from 'react';
import { Player } from '../../../types';
import { GenericLiveStream } from 'types/stream';
import sleep from '@anm/helpers/sleep';

type HookProps = {
  player: Player | null;
  setShowPoster: (show: boolean) => void;
  sources: MediaObject[];
  stream?: GenericLiveStream | null;
  canDestroy?: boolean;
};

const useWebinarVideo = ({ stream, player, sources, canDestroy, setShowPoster }: HookProps) => {
  const isWebinar = !!stream?.meta.webinarId;
  const streamVideo = sources.find(s => isStreamVideo(s.path))?.path;
  const isWebinarInProgress = !!(stream && stream.state === 'INPROGRESS');
  const canCheckWebinar = !!(stream && (stream?.state === 'SCHEDULED' || stream?.state === 'INPROGRESS'));
  const isWebinarAvailableAfterEnd = stream?.state === 'FINISHED' && !canDestroy && isWebinar;
  const [canShowLiveLabel, setCanShowLiveLabel] = useState(isWebinarInProgress);
  const [showStartLabel, setShowStartLabel] = useState(canCheckWebinar);
  const [hlsUrl, setHlsUrl] = useState(isWebinarAvailableAfterEnd ? stream?.result?.url : streamVideo);

  const handleAutoPlayReject = async () => {
    if (!player) return;

    await sleep(100);
    player.muted = true;
    player.play().catch(handleAutoPlayReject);
  };

  const checkStream = async () => {
    const streamUrl = stream?.result?.url;
    const canAutoPlay = !!(stream?.state === 'INPROGRESS' && streamUrl) && !player?.playing;

    if (canAutoPlay) {
      setHlsUrl(streamUrl);
      setShowPoster(false);
      setCanShowLiveLabel(true);
      setShowStartLabel(false);
      player!.play().catch(handleAutoPlayReject);
    }
  };

  useEffect(() => {
    const canCheckStream = player && canCheckWebinar;

    canCheckStream && checkStream();
  }, [player, canCheckWebinar, stream?.state, stream?.result?.url]);

  return [hlsUrl, showStartLabel, canCheckWebinar, canShowLiveLabel] as const;
};

export default useWebinarVideo;
